import styles from "./OnboardingStyles.module.css"
import { useState } from 'react';
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import { StepFormProps } from "../../types/onboarding.types";
import SecondaryButton from "../Button/SecondaryButton/SecondaryButton";
import OnboardingPopup from "./OnboardingPopup";
import { useTranslation } from "react-i18next";
/**
* Onboarding step.
*
* @param props StepFormProps
* @param {(step: number) => void} props.setStep - Step change handler
* @param {number} props.currentStep - Current step
* @param {OnboardingFormData} props.formData - Onboarding data
* @param {React.Dispatch<React.SetStateAction<OnboardingFormData>>} props.setFormData - Onboarding data change handler
* @param {() => void} props.clearData - Clear data handler
* @returns TSX.Element
*/
const Step6Form = ({currentStep, setStep, onPopup}:StepFormProps) => {
    const { t } = useTranslation(); // Translation
    const [chosenOption, setChosenOption] = useState<string>("") // Current chosen options
    const [popupOpen, setPopupOpen] = useState<boolean>(false) // Popup display state
    const handleLargeAction = () => {
        // redirect to email or smth
        alert("vytvorena poptavka")
    };
    // Selection logic
    const handleSelection = (premium: boolean, option: string) =>{
        if(premium){// Open popup
            setPopupOpen(true)
        }else{
            setChosenOption(option)
        }
    }
    // Handle part skip
    const handleSkip = ()=>{
        setStep(currentStep+1)
    }
    
    return(
        <>
        {/*Large action popup */}
        <OnboardingPopup
            titleKey="onboarding.steps.6.popup.title"
            contentKey="onboarding.steps.6.popup.content"
            display={popupOpen}
            onClose={() => setPopupOpen(false)}
            onSubmit={() => handleLargeAction()}
            onPopup={onPopup}
        />
        <div className={styles.OnboardingContent}>
            <div className={styles.Container}>
                <div className={styles.SecondaryTitle}>
                    <p>{t("onboarding.steps.6.title")}</p>
                </div>
                <div className={styles.SizedChoiceButtons}>
                    <SecondaryButton onClick={()=>handleSelection(true, "out")} text={t("onboarding.steps.6.buttons.outdoors")} className={`${chosenOption =="out" ? `${styles.ChosenOption}` : undefined} ${styles.ChoiceButtonRound}`} showChevron={false} colorVariant="primary"/>
                    <SecondaryButton onClick={()=>handleSelection(true, "in")} text={t("onboarding.steps.6.buttons.indoors")}  className={`${chosenOption =="in" ? `${styles.ChosenOption}` : undefined} ${styles.ChoiceButtonRound}`} showChevron={false} colorVariant="primary"/>
                    <SecondaryButton text={t("onboarding.steps.6.dismiss")} className={`${chosenOption =="none" ? `${styles.ChosenOption}` : undefined} ${styles.ChoiceButtonRound}`} colorVariant="primary" onClick={()=>handleSelection(false, "none")} showChevron={false}/>
                </div>
                <div  className={styles.ContinueButton}>
                    <PrimaryButton onClick={()=>handleSkip()} text={t("buttons.proceed")}/>
                </div>
            </div>
        </div>
        </>
    )
};

export default Step6Form;
